<template>
  <section class="section">
    <div class="container">
      <h2 class="section-title">五大区域算力中心</h2>
      <p class="section-lead">全国布局高品质机房节点，5个国标A级或T3/T3+标准机房，三线网络接入</p>
      <div class="instance-table datacenters-table">
        <table>
          <thead>
            <tr>
              <th>机房名称</th>
              <th>机房等级</th>
              <th>网络配置</th>
              <th>现有资源</th>
              <th>三线平均Ping值</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in datacenters" :key="d.name">
              <td>{{ d.name }}</td>
              <td>{{ d.level }}</td>
              <td>{{ d.network }}</td>
              <td>{{ d.resource }}</td>
              <td>{{ d.ping }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="commitments-grid">
        <div v-for="c in commitments" :key="c.title" class="feature-card">
          <h3>{{ c.title }}</h3>
          <p v-html="c.html" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const datacenters = [
  { name: '中国移动·呼和浩特数据中心', level: '国标A级', network: '三线', resource: '30台', ping: '34.2 ms' },
  { name: '淮海大数据中心', level: 'T3+ 标准', network: '三线', resource: '300台', ping: '35.1 ms' },
  { name: '武当云谷大数据中心', level: 'T3 标准', network: '三线', resource: '300台', ping: '31.0 ms' },
  { name: '广州南翔云数据中心', level: 'T3+ 标准', network: '三线', resource: '120台', ping: '38.4 ms' },
  { name: '中国移动(贵州)数据中心', level: '国标A级', network: '三线', resource: '132台', ping: '31.3 ms' }
];

const commitments = [
  {
    title: '极速交付承诺（机房配套完备、硬件现货场景）',
    html: '15 天 —— 百卡级标准化算力集群<br>30 天 —— 千卡级标准化算力集群<br>90 天 —— 万卡级标准化算力集群'
  },
  {
    title: '高标准SLA承诺',
    html: '单服务器可用性不低于99.9%<br>网络可用性不低于99%<br>核心故障秒级介入，7×24小时全域响应'
  },
  {
    title: '专业认证资质',
    html: 'ISO9001 质量认证（中英文）<br>IDC/ISP/CDN 增值电信业务许可<br>专业团队 10年+ 行业经验'
  }
];
</script>

<style scoped>
.section-lead {
  text-align: center;
  color: var(--fg-secondary);
  max-width: 700px;
  margin: 0 auto;
}

.datacenters-table {
  margin-top: 40px;
}

.commitments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 48px;
}

.commitments-grid h3 {
  font-size: 18px;
  margin-bottom: 18px;
}

.commitments-grid p {
  font-size: 15px;
  line-height: 1.65;
  color: #fff;
  opacity: 0.7;
}
</style>
